export default {
	text: {
		abort: 'Abort',
		automatic: 'Atomatic',
		autodrop: 'Drop automatically',
		bib: 'Bib',
		class: 'Class',
		club: 'Club',
		confirmHeatEnd: 'End Heat?',
		comment: 'Comment',
		deviceName: 'Devicename',
		displayFocusWatch: 'Show Focus-Watch',
		drop: 'Drop',
		dropAfterN: 'Best {n} from original Startlist',
		editValue: 'Edit result',
		entrants: 'Athletes',
		error500: 'Server not responding, please contact the Admin',
		errorLogin: 'Login failed',
		errorFirstTryDrop: 'First Try must not be droped',
		errorResultFound: 'There are already results for this height. Still want to delete?',
		errorInvalidInput: 'Input will lead to invalid results. Please check your input',
		errorMissingData: 'No data found',
		errorNoServerConnection: 'No connection to Server',
		errorUnknowen: 'Unknowen error',
		eventOverview: 'Event Overview',
		global: 'Global',
		height: 'Height',
		heightManager: 'Height-Editor',
		heightShort: 'm',
		hideEliminated: 'Hide eliminated athletes',
		interval: 'Interval',
		jumpOff: 'Jump Off',
		language: 'Language',
		lang: {
			'de-DE': 'Deutsch',
			'en-US': 'English (US)',
			'en-EN': 'English (UK)',
			'fr-CH': 'Français (CH)',
			'nl-NL': 'Dutch'
		},
		letIt: 'do not dismiss',
		listView: 'Listview',
		loading: 'Loading...',
		login: 'Login',
		logout: 'Logout',
		manual: 'Manual',
		message: 'Message',
		notStartetError: 'Event not gestartet',
		name: 'Name',
		next: 'Next',
		noData: 'No data',
		noRankingShort: 'wE',
		order: 'Order',
		orderIn: 'Sort in',
		overview: 'Overview',
		password: 'Password',
		poolMerge: 'Pool merge',
		poolMergeMessage: {
			request: 'Gruppen wirklich zusammenfügen?',
			errorToLessGroups: 'Zu wenig Gruppen zum Zusammenführen',
			errorAlreadyMerged: 'Die Gruppen wurden bereits zusammengeführt',
			errorResultsMissing: 'Es wurden noch nicht alle Ergebnisse erfasst',
			errorResultsMissing: 'Zusammenführung ist für diesen Bewerb nichtmöglich',
			mergeDone: 'Die Gruppen wurden auf einem anderen Endgerät zusammengeführt. Sie werden zur Bewerbsübersicht umgeleitet',
		},
		rank: 'Rank',
		ranking: 'Ranking',
		refresh: 'Refresh',
		redCard: 'Red Card',
		reset: 'Reset',
		result: 'Result',
		resultEdit: 'Result input',
		save: 'Save',
		send: 'Send',
		setCurrent: 'Set Current',
		setStartHeight: 'Set startheight',
		settings: 'Settings',
		seperateClasses: 'Handle categories separately',
		showEliminated: 'Show eliminated athletes',
		startHeat: 'Start heat',
		status: 'Status',
		startlist: 'Start list',
		state: {
			can: 'Can',
			dns: 'Dns',
			dsq: 'Dsq',
			finished: 'OK',
		},
		stopHeat: 'End Heat',
		singleHeight: "Single height",
		toastTimeLabel: 'Diplay duration for messages',
		toEntrie: 'Select Athlet',
		try: 'Try',
		tryShort: 'T',
		tryAutoLogin: 'try Autologin',
		wind: 'Wind',
		windShort: 'W',
		wkbHelp: 'Call Help',
		yellowCard: 'Yellow Card',
	},
};
